import * as getters from './getters'

let state = {
  version: '1.2.00',
  build: '2'
}

export default {
  namespaced: true,
  state,
  getters
}
